<template>
  <modal-wrapper :shown="editGroupModalShown" @hide="hideEditGroupModal">
    <div class="px-4">
      <div class="relative flex items-center justify-between">
        <div class="text-lg font-bold">Edit group</div>
        <div class="absolute top-0 right-0">
          <action-button type="outline-danger" @click="deleteGroup"
            >Delete</action-button
          >
        </div>
      </div>
      <div class="flex flex-col mt-6 space-y-4">
        <div>
          <field-label for="groupName">Name</field-label>
          <input-field type="text" id="groupName" v-model="group.name" />
        </div>
      </div>
      <action-button class="mt-6" @click="checkAndUpdateGroup">
        Save
      </action-button>
      <action-button class="mt-3" type="outline" @click="hideEditGroupModal">
        Cancel
      </action-button>
    </div>
  </modal-wrapper>
</template>

<script>
import { call, get, sync } from "vuex-pathify";

import ModalWrapper from "@/components/ModalWrapper";
import FieldLabel from "@/components/inputs/FieldLabel";
import InputField from "@/components/inputs/InputField";
import ActionButton from "@/components/inputs/ActionButton";

export default {
  props: ["groupToEdit"],
  components: {
    ModalWrapper,
    FieldLabel,
    InputField,
    ActionButton,
  },
  data() {
    return {
      group: {
        name: "",
      },
    };
  },
  computed: {
    favorites: get("favorites"),
    selectedFavoritesGroupIndex: get("selectedFavoritesGroupIndex"),
    selectedGroup() {
      return this.favorites[this.selectedFavoritesGroupIndex];
    },
    editGroupModalShown: sync("editGroupModalShown"),
  },
  watch: {
    groupToEdit: {
      handler: function () {
        if (this.groupToEdit.data) {
          this.group.name = this.groupToEdit.data.name;
        }
      },
      deep: true,
    },
  },
  methods: {
    deleteGroup() {
      this.$store.dispatch("deleteGroup", {
        groupIndex: this.selectedFavoritesGroupIndex,
      });
      this.hideEditGroupModal();
    },
    checkAndUpdateGroup() {
      if (this.group.name === "") {
        console.log("Please give your group a name");
      } else {
        this.updateGroup({
          groupIndex: this.selectedFavoritesGroupIndex,
          data: { ...this.group },
        });
        this.hideEditGroupModal();
      }
    },
    updateGroup: call("updateGroup"),
    hideEditGroupModal() {
      this.editGroupModalShown = false;
    },
  },
};
</script>